/**
 * How many CSS px one rem is right now: 16 at full size, 12.8 where index.css scales the UI to 80%
 * (screens 768-1365px wide), and more or less when the reader has changed the browser's text size.
 *
 * For code that positions or sizes something with arithmetic on measured px (getBoundingClientRect,
 * innerHeight): it turns a size the design gives in rem (a menu's 18rem cap, a w-56 popover) into px
 * at the scale on screen, so the sum agrees with what the browser actually draws. A size that needs
 * no arithmetic is better written in rem outright.
 *
 * Read on every call, not cached: the scale follows the window's width, which can change at any
 * time. 16 where nothing is laid out: no document (a server render), or a computed size that is not
 * in px (jsdom answers "medium", or the stylesheet's own "80%").
 */
export function remPx(): number {
  if (typeof document === 'undefined' || typeof getComputedStyle !== 'function') return 16;
  const size = /^(\d+(?:\.\d+)?)px$/.exec(getComputedStyle(document.documentElement).fontSize);
  const px = size ? Number(size[1]) : NaN;
  return px > 0 ? px : 16;
}
